import { render, staticRenderFns } from "./MyKad.vue?vue&type=template&id=052f54bc&"
import script from "./MyKad.vue?vue&type=script&lang=js&"
export * from "./MyKad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports